<div fxLayout="column" fxFlex class="cl-device-input cl-dynamic-element-input">
    <mat-form-field class="cl-device-number-input" fxLayout="column" fxFlex *ngIf="formControl && deviceInput.isVisible">

        <mat-label *ngIf="!hideTitle" fxLayout="row" class="text-contrast">{{ deviceInput.displayText }}</mat-label>
        <input
            class="text-contrast"
            matInput
            [formControl]="formControl"
            [disableControl]="!deviceInput.isEnabled"
            type="number"
        />
    </mat-form-field>

    <div class="validation-right" [ngClass]="alertClass" *ngIf="deviceInput.isVisible && formControl && formControl.errors && (formControl.errors.min || formControl.errors.max)">
        ( {{ deviceInput.minValue + "-" + deviceInput.maxValue }} )
    </div>

    <!--Invoke the recursive directive for each input associated with the dynamic input list.-->
    <dl-device-input fxLayout="row" fxFlex
        [deviceInfo]="deviceInfo"
        [deviceInput]="deviceInput.$sections"
        [deviceInputTemplate]="'inputSection'"
        [displayCount]="deviceInput.value"
        [deviceInputForm]="deviceInputForm"
    >
    </dl-device-input>
</div>
